const uuidVwo = () => {
  const uuid = window !== 'undefined' ? window._vwo_uuid : '';
  return uuid;
};

const accountVwo = () => {
  const id = window !== 'undefined' ? window._vwo_acc_id : '';

  return String(id);
};

const campaignDataVwo = () => {
  const campaign = window !== 'undefined' ? window._vwo_campaignData : {};
  return campaign;
};

const campaignDetailsVwo = (obj) => {
  let campaignId;
  let type;
  let typeId;
  for (const exp in obj) {
    campaignId = exp;
    type = obj[campaignId].n;
    typeId = obj[campaignId].c;
  }

  return { campaignId, type, typeId };
};

const campaignGoalsVwo = (campaignId) => {
  const vwoExp = window !== 'undefined' ? window._vwo_exp : '';
  const { goals } = vwoExp[campaignId];

  return goals;
};

export {
  uuidVwo,
  accountVwo,
  campaignDataVwo,
  campaignDetailsVwo,
  campaignGoalsVwo,
};
